module.exports = "<ng-progress></ng-progress>\r\n<router-outlet></router-outlet>\r\n<p-growl life=\"4000\"></p-growl>"


//////////////////
// WEBPACK FOOTER
// D:/SSW/Project/GSDP/Angular/gsdp_crm_angular/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main